// Shared by the SVG gallery and canvas homepage. CSS owns the size limit.
export function mastheadTitleScale(element, cssScale, viewWidth = 1200) {
    const maxWidth = parseFloat(getComputedStyle(element).getPropertyValue('--masthead-title-max-width')) || 960;
    return Math.min(1, maxWidth / (viewWidth * cssScale));
}

export function centeredTitleTransform(scale, x, y) {
    return `translate(${x} ${y}) scale(${scale}) translate(${-x} ${-y})`;
}

// Shared title row positions for the generated SVG and live gallery renderer.
export function workTitleRows(rows, small) {
    const x = small ? 380 : 600;
    const baselines = rows.length === 1 ? [small ? 345 : 295] : (small ? [245,410] : [205,385]);
    return rows.map((text,i) => [x,baselines[i],text]);
}
